import { createAction, createReducer } from "@reduxjs/toolkit"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { api } from "./helpers/api"
 
// ACTIONS
const requestedPartner = createAction("partner/requestedPartner")
const receivedPartner = createAction("partner/receivedPartner")
const failedPartner = createAction("partner/failedPartner")
 
// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  data:{},
}
 
const partnerReducer = createReducer(initialState, {
  [requestedPartner.type]: (state) => {
    setRequested(state)
  },
  [receivedPartner.type]: (state, action) => {
    setReceived(state)
    state.data = action.payload
  },
  [failedPartner.type]: (state) => {
    setFailed(state)
  }
})
export default partnerReducer
 
export const getPartner = (slug) => {
  return api({
    url: `/partners/${slug}`,
    method: "get",
    onStart: requestedPartner.type,
    onSuccess: receivedPartner.type,
    onError: failedPartner.type
  })
}
